import api from './api.js';

class States {
    constructor(){
        this.url_states = 'states'
    }

    all(){
        return api.get(this.url_states);
    }
}

export default new States;
